module.exports = __webpack_public_path__ + "img/us-bg.0bc99838.png";